module.exports = __webpack_public_path__ + "static/house-5-4caeb4290e63149d769e77db98285852.png";